<template>
    <div>
        <h1>{{$t('global.menu.questions.packs')}}</h1>
        <div class="row" v-if="items">
            <PackCard v-for="(item, index) in items" v-if="item" v-bind:item="item" :key="index"></PackCard>
        </div>
        <span v-if="items.length == 0">{{$t('packs.list.empty')}}</span>
        <pagination v-bind:view="view" v-bind:getPage="getPage" :responsive="false"></pagination>
    </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex';
import Pagination from '../app/Pagination';
import PackCard from './Card';

export default {
    components: {Pagination, PackCard},
    computed: mapGetters({
        items: 'pack/list/items',
        view: 'pack/list/view',
    }),
    methods: mapActions({
        getPage: 'pack/list/getItems',
    }),
    created() {
        this.$store.dispatch('pack/list/getItems');
    },
};
</script>



// WEBPACK FOOTER //
// src/components/pack/List.vue